import request from '@/utils/request2'

// 列表(主数据列表)
export function loadActivityWarningInfoListDataApi(data) {
  return request({
    url: 'tms-web/activityWarningInfoList/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportActivityWarningInfoListDataApi(data) {
  return request({
    url: 'tms-web/activityWarningInfoList/exportByPage',
    method: 'post',
    data
  })
}

// 代办数量
export function countTodoActivityWarningInfoListListDataApi(data) {
  return request({
    url: 'tms-web/activityWarningInfoList/countTodo',
    method: 'post',
    data
  })
}

// 查看
export function viewActivityWarningInfoListApi(data) {
  return request({
    url: 'tms-web/activityWarningInfoList/view',
    method: 'post',
    data
  })
}

// 执行处理
export function updateActivityWarningInfoListProcessApi(data) {
  return request({
    url: 'tms-web/activityWarningInfoList/updateProcess',
    method: 'post',
    data
  })
}